import { createIcon } from '../icon'
import MenuCloseIcon from '../svg/MenuCloseIcon'

export const MenuCloseIconDefault = createIcon(MenuCloseIcon)
